export default 'production'
// export default 'development'



// WEBPACK FOOTER //
// ./src/mode.js